import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Colors, helperButtonReset, helperLinkReset } from '@utex/ui-kit';

import { ViewType } from '../../types';

export interface ItemProps {
  isActive: boolean;
  view: ViewType;
}

function getUnderlineColor(props: ItemProps) {
  if (props.isActive) {
    switch (props.view) {
      case 'white':
        return Colors.text.inverse;

      case 'black':
        return Colors.text.default;

      default:
        return Colors.ut.alert;
    }
  }

  return 'transparent';
}

export const Container = styled('div')`
  display: flex;
  justify-content: center;

  @media (max-width: 1200px) {
    display: none;
  }
`;

export const Item = styled('a')<ItemProps>`
  ${helperLinkReset};
  ${helperButtonReset};
  position: relative;
  display: flex;
  align-items: center;
  padding: 0.8rem 0 0.8rem;
  margin-bottom: -2px;
  border-bottom: 2px solid ${(props) => getUnderlineColor(props)};
  color: inherit;
  transition: opacity 0.3s, color 0.3s, border-bottom 0.3s;

  &:not(:last-child) {
    margin-right: 3rem;
  }

  ${(props) =>
    !props.isActive &&
    css`
      &:hover,
      &:focus {
        opacity: 0.5;
      }

      &:active {
        opacity: 1;
      }
    `};
`;

export const dropdown = css`
  position: absolute;
  top: 0.7rem;
  right: -1.7rem;
`;
